import BaseLayout from "../../../components/base_layout";
import Head from "next/head";
import {
  Alert,
  AlertIcon,
  TableCaption,
  Thead,
  Box,
  Text,
  Link,
  LinkOverlay,
  UnorderedList,
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  Tab,
  TabPanel,
  Tabs,
  TabList,
  TabPanels,
  ListItem,
  Tfoot,
  Button,
  Image,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  VStack,
  Heading,
  LinkBox,
  Stack,
  Badge,
  Center,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from "@chakra-ui/react";
import { check_vat, remove_comma } from "../../../provider/common";
import { EmptyCart } from "../../../provider/cart";
import { GetCookie, lifecycle } from "../../../provider/common";
import { isMemberCheck, isLoginCheck } from "../../../provider/auth";
import React, { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  Pagination,
  Navigation,
  EffectFade,
} from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
SwiperCore.use([Autoplay, Pagination, Navigation, EffectFade]);
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import sorter from "sort-nested-json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBroadcastTower,
  faSearchPlus,
  faHeart as faHeart,
} from "@fortawesome/free-solid-svg-icons";
import BulkEstimateBox from "../../../components/bulkestimatebox";

// 전역변수
const axios = require("axios").default;

function PartView({ data }) {
  const router = useRouter();
  const [item_data, setItem_data] = useState(data);
  const [item_code, setItem_code] = useState(data.code);
  const [item_info, setItem_info] = useState(data.info);
  const [it_id, setIt_id] = useState(data.info.it_id);
  const [it_name, setIt_name] = useState(data.info.it_name);
  const [sku, setSku] = useState(data.info.it_8);
  const [it_maker, setIt_maker] = useState(data.source);
  const [it_basic, setIt_basic] = useState(data.info.it_basic);
  const [origin_pn, setOrigin_pn] = useState(data.sku);
  const [packaging, setPackaging] = useState(data.info.packaging);
  const [max_qty, setMax_qty] = useState(data.info.qty);
  const [min_qty, setMin_qty] = useState(data.info.moq);
  const [multiple, setMultiple] = useState(1);
  const [total_qty, setTotal_qty] = useState(data.info.moq);
  const [prices, setPrices] = useState(data.prices);
  const [userType, setUserType] = useState(data.user_type);

  const [unit_price, setUnit_price] = useState(data.info.it_price);

  const [is_stock, setIs_stock] = useState(data.info.is_stock);
  const [url, setUrl] = useState(data.info.is_stock);
  const [manufacturer_str, setManufacturer_str] = useState(
    data.manufacturer_str
  );
  const [manufacturer, setManufacturer] = useState(data.manufacturer);
  const [big_category, setBig_category] = useState("");
  const [mid_category, setMid_category] = useState("");
  const [small_category, setSmall_category] = useState("");

  const [total_price, setTotal_price] = useState(0);
  const [total_price_vat, setTotal_price_vat] = useState(0);
  const [info, setInfo] = useState(data.info);
  const [code, setCode] = useState(data.code);
  const [lifeCycle] = useState(data.info.it_4_subj);

  const [changeImg, setChangeImg] = useState("img1");
  const [it_brand, setItBrand] = useState(data.info.it_brand);
  const [logistic_weather, setLogistic_weather] = useState({
    it_maker: "onechip",
    period_end: "2022-02-10 (목)",
    period_start: "2022-02-03 (목)",
    weather_str: "선적날씨 - 맑음(정상출고)",
    weather_txt: "sun",
  });

  // 페이지 로드 시 스크롤을 상단으로 이동 (최초 한 번만)
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, []);

  useEffect(() => {
    setUrl(window.location.href);
    setCode(data.code);
    // 가격 데이터가 있을때만 반영 하도록 변경
    if (data.prices.length > 0) {
      const priceLastIdx = data.prices.length - 1;
      if (data.info.unit_no === null) {
        setMultiple(1);
      } else {
        setMultiple(data.info.unit_no);
      }
      // 기본 단가 반영 (회원가와 비회원가 상관없음)
      setUnit_price(remove_comma(data.prices[priceLastIdx].Price));
    } else {
      setMultiple(1);
      setUnit_price(0);
    }

    if (data.info.unit_no === null) {
      setMultiple(1);
    } else {
      setMultiple(data.info.unit_no);
    }
    // setUnit_price(55550);

    //setUnit_price(remove_comma(data.prices[priceLastIdx].Price));

    //전체 금액 구하기
    // category 담기
    // 카테고리 값이 없을 수도 있음
    if (data.category[2]) {
      setBig_category(data.category[2].name);
    }
    if (data.category[1]) {
      setMid_category(data.category[1].name);
    }
    if (data.category[0]) {
      setSmall_category(data.category[0].name);
    }
  }, []);

  // 결제
  // 견적바구니 추가
  async function AddQuoteCart(it_id, total_qty, it_maker, it_brand, it_name) {
    // 로그인 체크
    if ((await isLoginCheck()) === false) {
      router.push("/auth/login?before=/parts/inventory/" + it_id);
      return;
    }
    //견적바구니 쿠키값이 있는지 체크하기
    const data = [
      {
        it_id: it_id,
        it_brand: it_brand,
        it_name: it_name,
        it_maker: it_maker,
        qty: Number(total_qty),
      },
    ];

    goOrder(data);

    // 구매수량과 구매단위 일치 불일치 공식
    // 구매수량과 구매단위이 불일치할 때
    // if (data.quantity % multiple != 0) {
    //   // 구매수량을 구매단위로 나눴을 때 나머지가 있는 상태일 때
    //   alert("구매단위에 벗어나는 수량입니다.");
    //   // 구매수량과 구매단위가 일치할 때
    // } else if (data.quantity % multiple === 0) {
    //   goOrder(data);
    //   return;
    // }
  }

  const goOrder = async (data) => {
    const token = await GetCookie("token");

    // 구매수량을 구매단위로 나눴을 때 나머지가 없는 상태일 때
    const res = await axios.post(
      process.env.PANDA_API_URL + "/api/mall/insertQuoteLists",
      data,
      {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ` + token,
        },
      }
    );
    // 견적바구니에 저장
    if (res.status === 201) {
      var result = window.confirm(
        "견적바구니에 저장되었습니다. 견적바구니로 이동할까요?"
      );
      // 견적바구니에 이동
      if (result) {
        window.location.href = "/marketplace/cart";
      }
      // 최대 구매수량을 초과했을 때 발생
    } else {
      alert("견적바구니 저장중 오류가 발생했습니다. \n사유 : " + res.data.msg);
    }
  };

  const handleChange = (value) => {
    set_total_price(value);
  };

  const set_total_price = async (qty) => {
    //수량별 단가 계산
    // let unit_price = 0;
    let total_price = 0;
    let i = 0;
    if (prices.length > 0) {
      //우선 수량 낮은 순으로 정렬
      const ordered = sorter.sort(prices).asc("Quantity");
      ordered.forEach((element) => {
        if (qty >= element.Quantity) {
          // 회원가 비회원가 관계 없이 회원가로 통일
          unit_price = remove_comma(element.Price);
        }
      });
    } else {
      setUnit_price(0);
    }
    total_price = unit_price * qty;

    setTotal_price(total_price);
    setTotal_price_vat(total_price + check_vat(total_price));
    setTotal_qty(qty);
  };

  // 패키지(data.info.packaging)이 null 혹은 공백값일 때 N/A 넣기
  const isNullPacakageCheck = (value) => {
    const blank_pattern = /^\s+|\s+$/g;
    // 패키지 값이 null일 때
    if (value == null) {
      return "N/A";
    }
    // 패키지 값이 공백일 때
    if (value.replace(blank_pattern, "") == "") {
      return "N/A";
    }
    // 패키지 값이 그 외일 때
    return value;
  };

  const changeImgNow = async (e) => {
    setChangeImg(e.target.value);
  };

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              image: [
                item_info.it_img1.length === 0
                  ? process.env.PANDA_LIVE_URL + "/images/no_img.png"
                  : item_info.it_img1,
              ],
              "@context": "http://schema.org",
              "@type": "Product",
              description: `${manufacturer_str} 대리점 판매점 구매대행, 전자부품 설명:${item_info.it_basic}`,
              name: `[${manufacturer}]${it_name}`,
              manufacturer: manufacturer,
              sku: code,
              mpn: it_name,
              brand: manufacturer,
              review: {
                "@type": "Review",
                reviewRating: {
                  "@type": "Rating",
                  ratingValue: 4,
                  bestRating: 5,
                },
                author: {
                  "@type": "Person",
                  name: "Panadaparts",
                },
              },
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: 4.4,
                reviewCount: 89,
              },
              offers: {
                "@type": "Offer",
                availability: "http://schema.org/InStock",
                price: `${Math.trunc(
                  10000
                  // prices[prices.length - 1].price_before /
                  //   prices[prices.length - 1].Quantity
                )}`,
                priceValidUntil: "2030-12-31",
                priceCurrency: "KRW",
                url: process.env.PANDA_LIVE_URL + "/parts/inventory/" + code,
                inventoryLevel: item_info.qty,
                seller: {
                  "@type": "Organization",
                  name: "파츠고(판다파츠)",
                },
                hasMerchantReturnPolicy: {
                  "@type": "MerchantReturnPolicy",
                  applicableCountry: "KR",
                  returnPolicyCategory:
                    "https://schema.org/MerchantReturnFiniteReturnWindow",
                  merchantReturnDays: 14,
                  returnFees: "https://schema.org/FreeReturn",
                  returnMethod: "https://schema.org/ReturnByMail",
                },
                shippingDetails: {
                  "@type": "OfferShippingDetails",
                  shippingRate: {
                    "@type": "MonetaryAmount",
                    value: 3000,
                    currency: "KRW",
                  },
                  shippingDestination: {
                    "@type": "DefinedRegion",
                    addressCountry: "KR",
                  },
                  shippingService: "로젠택배",
                  deliveryTime: {
                    "@type": "ShippingDeliveryTime",
                    handlingTime: {
                      "@type": "QuantitativeValue",
                      minValue: 0,
                      maxValue: 1,
                      unitCode: "DAY",
                    },
                    transitTime: {
                      "@type": "QuantitativeValue",
                      minValue: 1,
                      maxValue: 3,
                      unitCode: "DAY",
                    },
                  },
                },
              },
            }),
          }}
        />
      </Head>

      <NextSeo
        title={it_name + ""}
        description={
          manufacturer_str !== ""
            ? it_name + manufacturer_str + " - " + it_basic
            : it_name + manufacturer + " - " + it_basic
        }
        canonical={process.env.PANDA_LIVE_URL + "/parts/inventory/" + code}
        openGraph={{
          url: process.env.PANDA_LIVE_URL + "/parts/inventory/" + code,
          title: it_name + " " + manufacturer,
          description: it_basic,
        }}
      />

      <BaseLayout>
        <Box className="base_container mall_view">
          <Breadcrumb
            fontWeight="medium"
            fontSize="sm"
            mt="1"
            paddingBottom="4"
            className="part_view_bc"
          >
            <BreadcrumbItem isCurrentPage color="#E53E3E" fontWeight="bold">
              <BreadcrumbLink href="#">{it_name}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>

          <Flex
            className="mallview_info"
            templateRows="repeat(2, 1fr)"
            templateColumns="repeat(3, 1fr)"
            gap={4}
          >
            <VStack className="mallview_info_img">
              <Box
                className="mallview_pd_img"
                p={4}
                color="white"
                border="1px"
                borderColor="gray.200"
              >
                {changeImg === "img1" ? (
                  <Image
                    bg=""
                    w="100%"
                    h="auto"
                    p={4}
                    color="white"
                    borderColor="gray.200"
                    alt="parts_img"
                    src={
                      item_info.it_img1 !== null &&
                      item_info.it_img1.indexOf("https") !== -1
                        ? item_info.it_img1
                        : "/images/no_img.png"
                    }
                  />
                ) : changeImg === "img2" ? (
                  <Image
                    bg=""
                    w="100%"
                    h="auto"
                    p={4}
                    color="white"
                    borderColor="gray.200"
                    alt="parts_img"
                    src={
                      item_info.it_img2 !== null &&
                      item_info.it_img2.indexOf("https") !== -1
                        ? item_info.it_img2
                        : "/images/no_img.png"
                    }
                  />
                ) : changeImg === "img3" ? (
                  <Image
                    bg=""
                    w="100%"
                    h="auto"
                    p={4}
                    color="white"
                    borderColor="gray.200"
                    alt="parts_img"
                    src={
                      item_info.it_img3 !== null &&
                      item_info.it_img3.indexOf("https") !== -1
                        ? item_info.it_img3
                        : "/images/no_img.png"
                    }
                  />
                ) : changeImg === "img4" ? (
                  <Image
                    bg=""
                    w="100%"
                    h="auto"
                    p={4}
                    color="white"
                    borderColor="gray.200"
                    alt="parts_img"
                    src={
                      item_info.it_img4 !== null &&
                      item_info.it_img4.indexOf("https") !== -1
                        ? item_info.it_img4
                        : "/images/no_img.png"
                    }
                  />
                ) : changeImg === "img5" ? (
                  <Image
                    bg=""
                    w="100%"
                    h="auto"
                    p={4}
                    color="white"
                    borderColor="gray.200"
                    alt="parts_img"
                    src={
                      item_info.it_img5 !== null &&
                      item_info.it_img5.indexOf("https") !== -1
                        ? item_info.it_img5
                        : "/images/no_img.png"
                    }
                  />
                ) : (
                  ""
                )}
              </Box>

              {data.info.it_img1 != null &&
              data.info.it_img2 === null &&
              data.info.it_img3 === null &&
              data.info.it_img4 === null &&
              data.info.it_img5 === null ? (
                ""
              ) : (
                <Box className="category_view_list">
                  <Swiper spaceBetween={10} slidesPerView={3} navigation={true}>
                    {data.info.it_img1 != null ? (
                      <SwiperSlide>
                        <button
                          value="img1"
                          style={{
                            backgroundImage: `url("${data.info.it_img1}")`,
                          }}
                          onClick={changeImgNow}
                        ></button>
                      </SwiperSlide>
                    ) : (
                      ""
                    )}
                    {data.info.it_img2 != null ? (
                      <SwiperSlide>
                        <button
                          value="img2"
                          style={{
                            backgroundImage: `url("${data.info.it_img2}")`,
                          }}
                          onClick={changeImgNow}
                        ></button>
                      </SwiperSlide>
                    ) : (
                      ""
                    )}
                    {data.info.it_img3 != null ? (
                      <SwiperSlide>
                        <button
                          value="img3"
                          style={{
                            backgroundImage: `url("${data.info.it_img3}")`,
                          }}
                          onClick={changeImgNow}
                        ></button>
                      </SwiperSlide>
                    ) : (
                      ""
                    )}
                    {data.info.it_img4 != null ? (
                      <SwiperSlide>
                        <button
                          value="img4"
                          style={{
                            backgroundImage: `url("${data.info.it_img4}")`,
                          }}
                          onClick={changeImgNow}
                        ></button>
                      </SwiperSlide>
                    ) : (
                      ""
                    )}
                    {data.info.it_img5 != null ? (
                      <SwiperSlide>
                        <button
                          value="img5"
                          style={{
                            backgroundImage: `url("${data.info.it_img5}")`,
                          }}
                          onClick={changeImgNow}
                        ></button>
                      </SwiperSlide>
                    ) : (
                      ""
                    )}
                  </Swiper>
                </Box>
              )}

              <Box className="mallview_sheet">
                <Text fontSize="sm" letterSpacing={-1}>
                  위 상품 이미지는 참고용이며, 실제 제품과 다를 수 있습니다.
                  <br></br>
                  {item_data.info.datasheet === null ||
                  item_data.info.datasheet === "null" ||
                  item_data.info.datasheet === "" ||
                  item_data.info.datasheet === undefined ||
                  item_data.info.datasheet === "undefined" ? (
                    <Button
                      className="item-non-dataSheet"
                      variant="outline"
                      w="100%"
                      h="40px"
                      mt={5}
                      mb={2}
                      size={12}
                      borderRadius={3}
                    >
                      데이터시트
                    </Button>
                  ) : (
                    <Link href={item_data.info.datasheet} target="_blank">
                      <Button
                        colorScheme="red"
                        variant="outline"
                        w="100%"
                        h="40px"
                        mt={5}
                        mb={2}
                        size={12}
                        borderRadius={3}
                      >
                        데이터시트
                      </Button>
                    </Link>
                  )}
                  정확한 사양은 위의 데이터시트에서 확인하세요.
                </Text>
              </Box>
            </VStack>

            <Box className="mallview_info_box">
              <Heading as="h1" size="lg">
                {it_name}
              </Heading>
              <Text fontSize="md" color="#555" mt="2">
                {it_basic
                  ? it_basic.length > 65
                    ? `${it_basic.slice(0, 65)}...`
                    : it_basic
                  : it_basic}
              </Text>
              <LinkBox as="article" p="1">
                <Box className="mallview_info_content" mt={2} lineHeight={10}>
                  <ul>
                    <li className="mallview_info_content-manu">
                      <span>제조사</span>
                      <h2>
                        {manufacturer_str !== ""
                          ? manufacturer_str.length > 37
                            ? `${manufacturer_str.slice(0, 37)}...`
                            : manufacturer_str
                          : manufacturer.length > 37
                          ? `${manufacturer.slice(0, 37)}...`
                          : manufacturer}
                      </h2>
                    </li>
                    <li>
                      <span>유통사</span>
                      <span>{it_maker.toUpperCase()}</span>
                    </li>
                    <li className="mallview_info_content-mpn">
                      <span>MPN</span>
                      <span>{it_name}</span>
                    </li>
                    <li>
                      <span>SKU</span>
                      <span>{sku}</span>
                    </li>
                    <li>
                      <span>PACKAGING</span>
                      <span> {isNullPacakageCheck(packaging)}</span>
                    </li>
                    <div className="goods_detail_line"></div>
                    <li>
                      <span>재고</span>

                      <span>{max_qty.toLocaleString()} 개</span>
                    </li>
                    <li>
                      <span>최소 구매수량(MOQ)</span>
                      <span>{min_qty.toLocaleString()} 개</span>
                    </li>
                    <li>
                      <span>구매단위(Multiple)</span>
                      {multiple > 0 ? (
                        <span>{multiple.toLocaleString()} 개</span>
                      ) : (
                        ""
                      )}{" "}
                    </li>
                    <li>
                      <span>수량</span>
                      <span>
                        {" "}
                        {min_qty > 0 ? (
                          <NumberInput
                            width="120px"
                            defaultValue={min_qty}
                            min={min_qty}
                            max={max_qty}
                            step={multiple}
                            onChange={handleChange}
                          >
                            <NumberInputField />
                            <NumberInputStepper>
                              <NumberIncrementStepper />
                              <NumberDecrementStepper />
                            </NumberInputStepper>
                          </NumberInput>
                        ) : (
                          ""
                        )}
                      </span>
                    </li>
                    <div className="goods_detail_line"></div>
                  </ul>
                </Box>

                <Stack
                  direction="row"
                  spacing={2}
                  align="center"
                  mt="5"
                  className="mall_view_btns"
                >
                  <Button
                    bg="#111"
                    _hover={{ bg: "#71717b;" }}
                    color="#fff"
                    size="lg"
                    padding="8"
                    marginTop={5}
                    fontSize="14"
                    borderRadius={3}
                    className="mallview_add_cart_btn"
                    onClick={() =>
                      AddQuoteCart(
                        it_id,
                        total_qty,
                        it_maker,
                        it_brand,
                        it_name
                      )
                    }
                  >
                    견적바구니
                  </Button>
                </Stack>
              </LinkBox>
            </Box>

            <Box
              className="mallview_info_qty"
              p={4}
              color="
                      #555"
              border="1px"
              borderColor="#E1E1E1"
            >
              <Alert status="error">
                <AlertIcon />
                <Heading as="h4" size="md">
                  재고 {max_qty.toLocaleString()}
                  <Text fontSize="sm" color="#555" fontWeight={500} mt="1">
                    최소구매수량(MOQ): {multiple.toLocaleString()}
                  </Text>
                </Heading>
              </Alert>

              <Table
                variant="simple"
                size="sm"
                mt={5}
                className="price_table"
              ></Table>
              <LinkBox
                align="center"
                as="article"
                maxW="sm"
                p="4"
                borderWidth="1px"
                rounded="md"
                border="1px"
                borderColor="#E1E1E1"
              >
                <Heading size="md">
                  <FontAwesomeIcon
                    icon={faBroadcastTower}
                    fontSize="5px!important"
                    size="md"
                  />{" "}
                  판다봇 AI 캐스터
                </Heading>
                <Text fontSize="10px">최근 출고 상태를 반영한 예상 일정</Text>
                <Heading size="md" my="2" lineHeight="1.5">
                  <LinkOverlay href="#">
                    {logistic_weather.period_start} ~ <br></br>
                    {logistic_weather.period_end}
                  </LinkOverlay>
                </Heading>
                <Text mb="4" color="red.400">
                  이내 출고예정
                </Text>
                <UnorderedList fontSize={12} listStyleType="none">
                  <ListItem mb="5px">
                    {`${logistic_weather.weather_str}`}
                    <Image
                      display="inline"
                      src={`/images/weather/${logistic_weather.weather_txt}.png`}
                      width="18px"
                    />
                  </ListItem>
                  <ListItem mb="5px">
                    로젠택배 무료배송 (5만원 이상)
                    <br />그 외 배송비 3,000원
                  </ListItem>
                  {is_stock !== "KR" ? (
                    <ListItem mb="5px">해외재고 ({is_stock})</ListItem>
                  ) : (
                    <ListItem mb="5px">국내재고</ListItem>
                  )}
                  <ListItem mb="5px">판다파츠 상품번호: {item_code}</ListItem>
                </UnorderedList>
              </LinkBox>
              <BulkEstimateBox it_name={it_name} manufacturer={manufacturer} />
            </Box>
          </Flex>
          <Center className="mallview_ad">
            <Link href="/board/board_view?no=80&type=notice">
              <img
                src="/images/category_ad.png"
                alt="항공특송 배너"
                width="1000px"
              ></img>
            </Link>
          </Center>
          <Box
            bg=""
            w="100%"
            p={0}
            color="#555"
            mt="20"
            className="mallview_info_list_btn"
          >
            <Tabs colorScheme="red">
              <TabList>
                <Tab fontWeight="bold">상세정보</Tab>
                <Tab>고객후기(0)</Tab>
                <Tab>연관상품(0)</Tab>
                <Tab>대체상품(0)</Tab>
                <Tab>배송/교환/환불</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <div className="shipping tab-content">
                    <div className="tab-data">
                      <div>
                        <span className="tab-content-info">
                          {data.info.it_explan}
                        </span>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel>
                  <p></p>
                </TabPanel>
                <TabPanel>
                  <p></p>
                </TabPanel>
                <TabPanel>
                  <p></p>
                </TabPanel>
                <TabPanel>
                  <div className="shipping tab-content">
                    <div className="tab-data">
                      <h3>배송안내</h3>
                      <table data-number-column="false">
                        <colgroup>
                          <col width="200px" />
                          <col width="*" />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th rowSpan="1" colSpan="1">
                              <p>배송비</p>
                            </th>
                            <td rowSpan="1" colSpan="1">
                              <ul className="ak-ul">
                                <li>
                                  <p>
                                    제주도 및 기타 섬지역은 항공료 및 선박료가
                                    추가 될 수 있습니다.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    또한 제품의 무게 및 크기에 따라 추가
                                    배송비가 발생될 수 있으니, 이점 양해
                                    바랍니다.
                                  </p>
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <th rowSpan="1" colSpan="1">
                              <p>배송기간</p>
                            </th>
                            <td rowSpan="1" colSpan="1">
                              <ul className="ak-ul">
                                <li>
                                  <p>
                                    당일 해외 발주 마감은 유통사 15시 / 17시로
                                    나누어 2회 발주를 진행합니다.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    평균적으로 국내재고 상품은 입금 후 2~3일,
                                    해외재고는 입금 확인 후 3~15일이내 출고
                                    됩니다.
                                    <br />
                                    (도서 산간 지역은 1~2일 더 소요될 수
                                    있습니다.)
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    <Link href="/benefit/delay" target="_blank">
                                      예상 출고일이상 배송지연이 발생시 배송지연
                                      보상을 해드립니다.
                                    </Link>{" "}
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    단, 금요일 17시 이후 입금건은 월요일에
                                    주문처리 됩니다.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    휴일 주문(토/일, 법정공휴일)의 경우 다음
                                    영업일에 상품준비가 이루어집니다.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    판다파츠는 글로벌 유통사의 대리점 혹은
                                    판매점으로 해당 상품을 편리하게 구매대행을
                                    하고 있습니다.
                                  </p>
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <th rowSpan="1" colSpan="1">
                              <p>배송방법</p>
                            </th>
                            <td rowSpan="1" colSpan="1">
                              <ul className="ak-ul">
                                <li>
                                  <p>
                                    택배 - 로젠택배(1588-9988)
                                    <br />
                                    (발송 후 평균 1~2일 내 수령가능하며,
                                    택배사의 사정에 따라 다소 지연 될 수
                                    있습니다.)
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    퀵서비스 - 퀵서비스는 구매자 부담 (착불)
                                    입니다.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    퀵서비스는 서울/경기 일부 지역에서
                                    가능합니다.
                                  </p>
                                </li>
                                <li>
                                  <p>기타 화물등의 배송은 지원하지 않습니다.</p>
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <th rowSpan="1" colSpan="1">
                              <p>관세</p>
                            </th>
                            <td rowSpan="1" colSpan="1">
                              <ul className="ak-ul">
                                <li>
                                  <p>
                                    해외재고 상품의 경우 주문시 수입 및
                                    통관과정을 모두 책임지고 처리해드립니다.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    번거로운 통관 확인 작업없이, 빠르게 편리하게
                                    주문 하실 수 있습니다.
                                    <br />
                                    단, 일부 품목의 관세 발생시 출고전 관세 입금
                                    요청이 있을 수도 있습니다.{" "}
                                  </p>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <h3>교환/환불 안내</h3>
                      <table>
                        <colgroup>
                          <col width="200px" />
                          <col width="*" />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th rowSpan="1" colSpan="1">
                              <p>20일 교환/환불</p>
                            </th>
                            <td rowSpan="1" colSpan="1">
                              <ul className="ak-ul">
                                <li>
                                  <p>
                                    제품 수령 후 20일이내에 다음과 같은 사항이
                                    발생된 경우에 교환이 가능합니다.
                                  </p>
                                  <ul className="ak-ul">
                                    <li>
                                      <p>
                                        배송된 제품에 하자가 있거나, 기능상
                                        문제가 발생한 경우
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        해외 재고 주문 상품은 상품의 하자가 아닌
                                        경우(단순변심, 주문 실수)에 환불/취소가
                                        불가능합니다.(해당 유통사 정책)
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        주문 스펙 및 커팅, 릴제조 상품의 경우
                                        교환/반품이 되지 않습니다.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        ESD에 민감한 부품은 환불이 불가 할 수도
                                        있음
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        단, 상품에 따라 반품 비용은 해외선적
                                        비용(4만원)이 발행 할 수 있습니다.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        견적을 통해 별도로 구입한 물품은 구매
                                        취소 및 반품이 불가 할 수 있습니다.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Mil-Spec제품은 취소 및 반품이
                                        불가능합니다.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        사전에 ‘취소 불가 / 반품 불가’로 지정된
                                        부품은 반품 환불 불가
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        제조사에서 보증하는 반품은 제조사 보증
                                        및 반품/교환 조건의 정책에 따라
                                        다릅니다.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        부품에 대한 기술 문의는 해당 제조사로
                                        문의를 하셔야 합니다.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Chip Outpost 제품으로 지정된 부품은
                                        반품할 수 없습니다.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        불가항력 : 제품 분배, 원자재 부족, 노동
                                        쟁의, 운송 지연, 예상치 못한 상황,
                                        천재지변, 제3자의 작위 또는 부작위, 행정
                                        또는 군사 당국의 작위 또는 부작위,
                                        정부의 우선순위, 화재, 파업, 홍수,
                                        악천후, 컴퓨터 고장, 테러, 전염병, 격리
                                        규제, 폭동 또는 전쟁 등을 포함하되 이에
                                        국한되지 않고 합리적인 통제를 벗어나는
                                        이유로 인한 배송 지연 또는 의무 불이행에
                                        대해 배상책임을 지지 않습니다.
                                      </p>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <th rowSpan="1" colSpan="1">
                              <p>기타</p>
                            </th>
                            <td rowSpan="1" colSpan="1">
                              <ul className="ak-ul">
                                <li>
                                  <p>
                                    교환의 경우 로젠택배를 통해서 반품해 주셔야
                                    합니다.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    타 택배와 착불로 교환/반품 요청시 통보 없이
                                    반송처리 됩니다.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    모든 제품은 공급사의 사정에 따라 단가변동 및
                                    재고 소진이 발생 될수 있습니다.
                                  </p>
                                  <ul className="ak-ul">
                                    <li>
                                      <p>
                                        급작스러운 환율 변동에 의해 추가 금액을
                                        요청 할수 도 있으니, 양해바랍니다.{" "}
                                      </p>
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  <p>
                                    제품의 사용법등의 문의는 제조사에 직접
                                    문의를 해야합니다.
                                  </p>{" "}
                                </li>
                                <li>
                                  <p>
                                    판다파츠는 해당 제품의 유통사 / 대리점 /
                                    제조사를 대신해 쉽고 빠르게 구매를
                                    도와드리는 서비스입니다.
                                  </p>{" "}
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </Box>
      </BaseLayout>
    </>
  );
}

// This function gets called at build time
export async function getServerSideProps(context) {
  const { req, params, res } = context;
  const { cookies } = req;
  const code = params.code;
  const getdata = await axios.get(
    process.env.PANDA_API_URL + "/api/mallshop/detail/" + code,
    {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ` + cookies.token,
      },
    }
  );
  let data = [];

  if (getdata.data.status == 200) {
    data = getdata.data.data;
    data.code = code;
  } else {
    res.setHeader("location", "/");
    res.statusCode = 302;
    res.end();
  }

  // By returning { props: { posts } }, the Blog component
  // will receive `posts` as a prop at build time
  return {
    props: {
      data,
    },
  };
}

export default PartView;
